import React from "react";

import { Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { BlockStandard } from "components/admin/BlockStandard";

const useStyles = makeStyles()((theme) => ({
  buttonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(2, 1),
  },
}));

export const ButtonGrid: React.FC<ButtonGridProps> = ({
  children,
  showDivider = false,
}) => {
  const { classes } = useStyles();

  return (
    <BlockStandard hideDivider={!showDivider}>
      <Grid item container className={classes.buttonGrid}>
        {children}
      </Grid>
    </BlockStandard>
  );
};

export type ButtonGridProps = {
  children: React.ReactNode;
  showDivider?: boolean;
};
